interface IDownloadIcon {
  color?: string;
}

const DownloadIcon: React.FC<IDownloadIcon> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_1317_4154"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#FAF9FA" />
      </mask>
      <g mask="url(#mask0_1317_4154)">
        <path
          d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6ZM12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

DownloadIcon.defaultProps = {
  color: "transparent",
};

export default DownloadIcon;
